module.exports = __webpack_public_path__ + "media/Video 26.87383858.mp4";